import { Component } from 'react';

const collapsible = (WrappedComponent) => {
  class Collapsible extends Component {
    static displayName = `Collapsible(${WrappedComponent.displayName || WrappedComponent.name})`;

    static defaultProps = {
      defaultIsCollapsed: false,
      isCollapsed: undefined,
      onToggleCollapse() {},
    };

    constructor(props) {
      super(props);

      this.state = {
        isCollapsed: props.defaultIsCollapsed,
      };

      this.handleCollapse = this.handleCollapse.bind(this);
    }

    handleCollapse(...args) {
      const { onToggleCollapse } = this.props;
      this.setState((state) => ({
        isCollapsed: !state.isCollapsed,
      }));

      onToggleCollapse(...args);
    }

    render() {
      const { isCollapsed: isCollapsedState } = this.state;
      const { isCollapsed = isCollapsedState, defaultIsCollapsed, ...props } = this.props;

      return (
        <WrappedComponent
          {...props}
          isCollapsed={isCollapsed}
          onToggleCollapse={this.handleCollapse}
        />
      );
    }
  }

  return Collapsible;
};

export default collapsible;
